import { YStack, XStack, View, isWeb, useMedia } from 'tamagui'
import { useTranslation } from 'react-i18next'
import { IProductPage } from '@dtos/ProductPage'
import { MOBILE_BAR_STYLE } from './constants'
import { ctaKind } from './helpers'
import { usePricing } from './hooks'
import { BuyButton } from './BuyButton'
import { CurrentPrice, InstallmentLine } from './PriceParts'

// Barra fixa de compra no mobile (referência funcional: barra do checkout):
// preço + parcelas à esquerda, CTA à direita, sempre visível no scroll.
export function MobileBuyBar({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const media = useMedia()
  const { option, isFree, period, price, installment, installmentKey } =
    usePricing(product)

  if (!isWeb || media.gtSm || !option?.checkoutUrl) return null

  return (
    <XStack
      style={MOBILE_BAR_STYLE}
      backgroundColor="$bg-page"
      borderTopWidth={1}
      borderTopColor="$border-muted"
      paddingVertical={12}
      paddingHorizontal={16}
      alignItems="center"
      gap={16}
      testID="product-mobile-buy-bar"
    >
      {!isFree && (
        <YStack flexShrink={0}>
          <CurrentPrice
            price={price}
            period={period}
            color="$cta"
            fontSize={18}
            periodFontSize={12}
          />
          {installment && (
            <InstallmentLine
              installment={installment}
              installmentKey={installmentKey}
              color="$accent"
              fontSize={12}
            />
          )}
        </YStack>
      )}
      <View flex={1}>
        <BuyButton
          label={t(
            `ctaSecondary.${ctaKind(option, product.course?.kind ?? null)}`,
          )}
          url={option.checkoutUrl}
          location="mobile_bar"
          product={product}
          fullWidth
        />
      </View>
    </XStack>
  )
}
